module.exports = __webpack_public_path__ + "img/744.cc543f5d.jpg";